var map = {
	"./apple.png": 9667,
	"./asus.png": 7677,
	"./asus2.png": 6780,
	"./avatar.png": 8308,
	"./bayron.jpg": 3610,
	"./card_img.png": 5577,
	"./cart.png": 1648,
	"./cesar.jpg": 4555,
	"./coder.png": 7499,
	"./coder2.png": 7305,
	"./cris.jpg": 7674,
	"./cristina.jpeg": 9682,
	"./dell.png": 5299,
	"./edit.png": 8975,
	"./favourites-click.png": 40,
	"./favourites.png": 2591,
	"./fran.jpeg": 7954,
	"./fran.jpg": 309,
	"./gaston.jpg": 853,
	"./home.png": 6553,
	"./hp.png": 6221,
	"./intel.png": 9924,
	"./jbl.png": 2301,
	"./keyboard.png": 4592,
	"./lenovo.png": 6546,
	"./lg.png": 6538,
	"./login.png": 9520,
	"./logout.png": 6645,
	"./martin.jpg": 4718,
	"./martincho.jpeg": 5106,
	"./menu.png": 2675,
	"./news10.jpg": 5596,
	"./news11.jpg": 5236,
	"./news13.jpg": 408,
	"./news8.png": 3394,
	"./noticiasReal1.jpeg": 3245,
	"./noticiasReal2.jpeg": 5185,
	"./noticiasReal3.jpg": 2070,
	"./noticiasReal4.jpg": 4693,
	"./pcGamer1.jpg": 4230,
	"./pcGamer2.jpg": 8969,
	"./pcGamer3.jpg": 4253,
	"./pcGamer4.jpg": 8255,
	"./pcGamer5.jpg": 5114,
	"./pcGamer6.jpg": 218,
	"./rodri.jpeg": 2683,
	"./rodrigo.jpg": 5625,
	"./rodrigoz.jpg": 713,
	"./roge.jpeg": 4858,
	"./rogelio.jpeg": 9930,
	"./samsung.png": 3833,
	"./search.jpg": 1388,
	"./trash.png": 8849,
	"./trash2.png": 8319,
	"./trash3.png": 4405,
	"./unknow.jpg": 6230,
	"./user.png": 2315,
	"./whatsapp.png": 6656
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;